import * as React from 'react';

const SvgIconShrink = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width={24} height={25} fill="none" {...props}>
    <path
      d="M23.25 1.748l-9 9M9.75 21.998v-6.75H3M14.25 3.998v6.75H21M9.75 15.248l-9 9"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default SvgIconShrink;
